<template>
    <div class="container pull-up">
        <div class="row">
            <div class="col-md-12">
                <div class="card m-b-30">
                    <div class="card-header">
                        <h5 class="m-b-0">
                            <i class="mdi mdi-checkbox-intermediate"></i> {{ $t('supplier.button.all') }}
                        </h5>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <data-tables :data="suppliers.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
                                         :pagination-props="{ pageSizes: [10, 15, 30, 40, 100], pageSize: 10 }">
                                <el-table-column in label="S/N" type="index"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="name" label="Name"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="address" label="Address"></el-table-column>
                                <el-table-column class-name="text-center" :formatter="$formatPhone" prop="phone"
                                                 label="Phone Number"></el-table-column>
                                <el-table-column prop="user.name" label="Creator"></el-table-column>
                                <el-table-column prop="amt_owed" label="Owing" sortable>
                                    <template #default="scope">
                                        <span class="currency">{{ formatPrice (scope.row.amt_owed) }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="created_at" :formatter="$shortDate" label="Created At"
                                ></el-table-column>
                                <el-table-column label="Actions" min-width="150">
                                    <template #header="scope">
                                        <el-input v-model="search" size="mini" autofocus placeholder="Type to search"/>
                                    </template>
                                    <template #default="{$index, row}">
                                        <v-btn color="secondary" v-can.disable="'supplier.history'" x-small class="mx-1"
                                               :to="{name: 'supplier-history', params: {id: row.id}}">
                                            <i class="mdi mdi-history"></i> {{ $t('supplier.button.history') }}
                                        </v-btn>
                                        <el-dropdown trigger="click">
                                            <v-btn color="primary" x-small>
                                                Actions <i class="el-icon-arrow-down el-icon--right"></i>
                                            </v-btn>
                                            <el-dropdown-menu slot="dropdown">
                                                <el-dropdown-item v-can.disable="'supplier.update'" icon="mdi mdi-pencil" @click.native="edit(row.id)">
                                                    Edit Supplier
                                                </el-dropdown-item>
                                                <el-dropdown-item v-can.disable="'supplier.archive'" icon="mdi mdi-archive" @click.native="beforeArchive(row.id)">
                                                    Archive Supplier
                                                </el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </template>
                                </el-table-column>
                            </data-tables>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Index',
  data () {
    return {
      suppliers: [],
      search: ''
    }
  },
  methods: {
    async getSuppliers () {
      try {
        await this.withLoading(async () => {
          this.suppliers = await this.$supplierService.getSuppliers()
        }, 'loading')
      } catch (error) {
        // Error is already handled by the global interceptor
        console.log('Component caught error in getSuppliers:', error)
      }
    },
    beforeArchive (id) {
      const index = this.suppliers.findIndex(s => s.id === id)
      if (index === -1) {
        console.error('Supplier not found with id:', id)
        return
      }

      const supplier = this.suppliers[index]
      const supplierName = supplier?.name || 'this supplier'

      this.$confirm(
        this.$t('supplier.confirm.archive') + ` "${supplierName}"?`,
        this.$t('status.warning'),
        {
          confirmButtonText: this.$t('status.ok'),
          cancelButtonText: this.$t('status.cancel'),
          type: 'warning',
          dangerouslyUseHTMLString: false
        }
      ).then(() => {
        this.archive(index, id)
      }).catch(() => {
        // User cancelled the confirmation - do nothing
      })
    },
    async archive (index, id) {
      try {
        const supplierName = this.suppliers[index]?.name || 'Supplier'
        await this.withLoading(async () => {
          await this.$supplierService.archive(id)
          this.showSuccess(this.$t('supplier.archive.success', [supplierName]))
          this.suppliers.splice(index, 1)
        }, 'loading')
      } catch (error) {
        // Error is already handled by the global interceptor
        console.log('Component caught error in archive:', error)
      }
    },
    edit (id) {
      this.$router.push({ name: 'edit-supplier', params: { id } })
    }
  },
  mounted () {
    this.$emit('parent-title', this.$t('supplier.title.manage'))
    this.getSuppliers()
  }
}
</script>

<style scoped>

</style>
